import type { AbsSectorGroupKey } from '@/creditflowresearch/domain/Sector/AbsSectorGroup';
import { ALL_ABS_SECTOR_GROUP_KEYS } from '@/creditflowresearch/domain/Sector/constants';

export const selectAbsSectorGroupKeysFromQuery = (sectorsQuery: string | null | undefined): AbsSectorGroupKey[] => {
  const queryKeys = (sectorsQuery ?? '').split(',');
  const activeKeys = ALL_ABS_SECTOR_GROUP_KEYS.filter((key) => queryKeys.includes(key));

  return activeKeys.length > 0 ? activeKeys : [...ALL_ABS_SECTOR_GROUP_KEYS];
};
